<template>
  <es-form class="product-info" :disabled="waitPay">
    <div class="row base-info">
      <div class="row-label base-info-title">{{ $t('产品信息') }}</div>
      <div class="row-content base-info-detail">
        <div class="product-name">{{ commodityInfo.commodityName }}</div>
        <div class="product-desc" v-if="introduce">{{ introduce }}</div>
        <div class="base-property">
          <span class="property-item subscribe-content">
            <span class="subscribe-content-text">
              {{ $t('订阅内容：') }}
              <template v-if="commodityInfo.saleType === 1">
                {{ commodityInfo.packageName || commodityInfo?.packages?.[0]?.packageName || commodityInfo?.saleInfoName }}
              </template>
              <template v-else-if="commodityInfo.saleType === 3">
                {{ commodityInfo?.packageName || commodityInfo?.licenses?.[0]?.licenseName || commodityInfo?.saleInfoName }}
              </template>
              <template v-else>— —</template>
            </span>
            <es-tooltip class="item" placement="bottom-start" v-if="isTying && tyingInfo.length > 0">
              <template slot="content">
                <p v-for="(item, index) in tyingInfo" :key="index">{{ item.remark }}</p>
              </template>
              <es-button class="detail-btn" variant="text" theme="primary" size="mini">{{ $t('详情') }}</es-button>
            </es-tooltip>
          </span>
          <span class="property-item">{{ $t('有效期：') }}{{ commodityInfo?.effective }}</span>
          <span class="property-item" v-if="isPackageType">
            {{ $t('产品规格：') }}{{ commodityInfo.saleInfoTotalNum || totalNum }} {{ commodityInfo.units }}
          </span>
        </div>
        <div class="total-amount" v-if="!isRechargeType">
          <span class="unit">￥</span>
          <span>{{ unitPrice }}</span>
        </div>
      </div>
    </div>
    <div class="row" v-if="showAdditionalBenefits">
      <div class="row-label">{{ $t('附赠权益') }}</div>
      <div class="row-content row-content-benefit">
        <img class="row-content-benefit-logo" src="@/assets/common/additionalBenefitsLogo.png" alt="附赠权益logo">
        <div class="row-content-benefit-detail">{{ $t('DeepTax 财税助手标准版3个月') }}</div>
        <es-button class="benefits" variant="text" theme="primary" @click="viewBenefits" :disabled="false">
          {{ $t('查看权益说明') }}
        </es-button>
      </div>
    </div>
    <div class="row">
      <div class="row-label">{{ $t('购买主体') }}</div>
      <div class="row-content">
        <es-input data-esign-inject-name="禁用输入框" :value="userInfo.name" :disabled="true"></es-input>
      </div>
    </div>
    <div class="row" v-if="useTime || isContinuedValidityTerm === 1">
      <div class="row-label">{{ $t('生效时间') }}</div>
      <div class="row-content">
        <div class="effective-time-content">
          <es-select
            :value="isContinuedValidityTerm"
            :placeholder="$t('请选择')"
            class="order-time-select w-60"
            :disabled="!(commodityInfo?.billingProduct?.productType != 2 && !hideContinuedType)"
            @change="handleContinuedValidityTermChange">
            <template v-for="item in orderTimeSelaction">
              <es-option :key="item.value" :label="item.label" :value="item.value" v-if="item.value !== 1 || showAutoBuy"></es-option>
          </template>
        </es-select>
        <es-date-picker
          v-if="isContinuedValidityTerm === 2"
          class="order-time-picker w-60"
          v-model="useTime"
          type="date"
          unlink-panels
          :clearable="false"
          :picker-options="pickerOptions"
          value-format="timestamp"
          :disabled="disableTimeChange"
          @change="handleTimeChange" />
        </div>
        <div class="effective-explain" v-if="showAutoBuy && isContinuedValidityTerm === 1">
          <div>{{ $t('当前有生效中的订单，{data}到期', { data: expirationData }) }}</div>
          <div>{{ $t('续延订单在原订单结束后生效，或原订单提前消耗完续延订单自动生效。') }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="row-label">{{ isRechargeType ? $t('充值金额') : $t('购买数量') }}</div>
      <div class="row-content">
        <es-input
          v-if="isRechargeType"
          class="w-230"
          :placeholder="$t('请输入')"
          :value="count"
          :disabled="banNumContral"
          @input="handleInput"
          :min="1"
          @blur="getExel"></es-input>
        <es-input-number
          v-if="isPackageType"
          class="w-60"
          :value="num"
          @change="handleChange"
          :min="1"
          :max="max"
          :disabled="banNumContral" />
      </div>
    </div>
    <!-- 收货地址 -->
    <div class="row" v-if="isDeliver">
      <div class="row-label">{{ $t('收货地址') }}</div>
      <div class="row-content">
        <Address @getVal="getVal" :waitPay="waitPay" :addressInfo="addressInfo" />
      </div>
    </div>
    <div class="row">
      <div class="row-label">{{ $t('开发票') }}</div>
      <div class="row-content">
        <es-select :value="invoice" @change="handleInvoiceChange" :placeholder="$t('请选择')" class="w-230">
          <es-option v-for="item in invoiceOptions" :key="item.value" :label="item.label" :value="item.value"></es-option>
        </es-select>
        <InvoiceInfoDisplay
          v-if="invoice === 2"
          class="invoce-info"
          :invoiceInfo="invoiceForm"
          @edit="handleEditInvoice"
          :waitPay="waitPay" />
      </div>
    </div>

    <InvoiceInfo
      v-if="invoice === 2"
      :visible.sync="invoiceDialogVisible"
      @submit="handleInvoiceSubmit"
      :invoiceForm="invoiceForm"
      @closeInvoiceDialog="closeInvoiceDialog" />
    <ConvenientlyPurchase
      ref="convenientlyPurchase"
      :selectTyingSaleSchemaList="selectTyingSaleSchemaList"
      :isContinuedValidityTerm="isContinuedValidityTerm"
      @onTyingSaleSelectChange="(value, cache) => $emit('onTyingSaleSelectChange', value, cache)" />
  </es-form>
</template>

<script>
import { mapState } from 'vuex'
import { $t } from '@/locales'
import { formatDate } from '@/util.js'
import InvoiceInfo from './InvoiceInfo.vue'
import InvoiceInfoDisplay from './InvoiceInfoDisplay.vue'
import Address from './address/index.vue'
import ConvenientlyPurchase from './ConvenientlyPurchase.vue'
import { BENEFITS_MENU_IDS, benefitLink } from '@/consts/product'
export default {
  name: 'ProductInfo',
  components: {
    InvoiceInfo,
    InvoiceInfoDisplay,
    Address,
    ConvenientlyPurchase,
  },
  props: {
    hideContinuedType: {
      type: Boolean,
      default: false,
    },
    invoiceForm: {
      type: Object,
      default: () => ({}),
    },
    commodityInfo: {
      type: Object,
      default: () => ({}),
    },
    tyingInfo: {
      type: Object,
      default: () => [],
    },
    num: {
      type: [Number, String],
      default: 1,
    },
    count: {
      type: Number,
      default: 0,
    },
    totalNum: {
      type: Number,
      default: 0,
    },
    isContinuedValidityTerm: {
      type: Number,
      default: 2,
    },
    useTime: {
      type: Date,
      default: +new Date(),
    },
    invoice: {
      type: Number,
      default: 1,
    },
    waitPay: {
      type: Boolean,
      default: false,
    },
    showAutoBuy: {
      type: Boolean,
      default: false,
    },
    isTying: {
      type: Boolean,
      default: false,
    },
    isDeliver: {
      type: Boolean,
      default: false,
    },
    lastEndTime: {
      type: Number,
      default: 0,
    },
    // 顺手购商品列表
    selectTyingSaleSchemaList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      max: this.$route.query.max ? parseInt(this.$route.query.max) : 99999,
      orderTimeSelaction: [
        {
          value: 2,
          label: $t('指定时间生效'),
        },
        {
          value: 1,
          label: $t('订单续延生效'),
        },
      ],
      invoiceOptions: [
        {
          value: 1,
          label: $t('订单完成后开发票'),
        },
        {
          value: 2,
          label: $t('填写发票信息'),
        },
      ],
      useTime: +new Date(),
      num: Number(this.$route.query.num) || 1,
      invoiceDialogVisible: false,
      invoiceOperateType: 'add', // 发票信息操作类型： add 新增， edit 编辑
    }
  },
  watch: {
    invoice: {
      handler(v) {
        console.log('invoice>>', v)
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      // isOrg: state => state.isOrg,
      // tsignData: state => state.tsignData,
    }),
    pickerOptions() {
      const dayTimeStamp = 1000 * 60 * 60 * 24

      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - dayTimeStamp
        },
      }
    },
    // 充值金额类型
    isRechargeType() {
      return this.commodityInfo.saleType === 2
    },
    // 套餐类型
    isPackageType() {
      return this.commodityInfo.saleType === 1 || this.commodityInfo.saleType === 3
    },
    banNumContral() {
      return (
        Boolean(this.$route.query.banNumContral && this.$route.query.banNumContral !== 'undefined') ||
        this.commodityInfo.saleDisplayInfo?.banNumContral
      )
    },
    introduce() {
      // 商品接口和订单详情接口返回的介绍信息不一样，所以需要合并
      return this.commodityInfo.saleDisplayInfo?.introduce || this.commodityInfo.commoditySaleDisplay?.introduce
    },
    // 单价
    unitPrice() {
      // 订单页时显示详情接口返回的标准价格除数量，否则显示商品信息的单价
      if (this.waitPay) {
        return (this.commodityInfo?.standardPrice / this.num).toFixed(2)
      }

      return this.commodityInfo?.standardPrice?.toFixed(2) || '0.00'
    },
    // 订单延续到期时间
    expirationData() {
      return this.lastEndTime ? formatDate(new Date(this.lastEndTime), 'yyyy-MM-dd') : '--'
    },
    // 下单后订单收回地址回显
    addressInfo() {
      if (this.waitPay) {
        return this.commodityInfo?.addressInfo || null
      }

      return null
    },
    // 是否显示附赠权益说明
    showAdditionalBenefits() {
      const menuId = this.$route.query.menuId || this.commodityInfo?.saleInfoId || this.commodityInfo?.menu
      return BENEFITS_MENU_IDS.includes(menuId?.toString())
    },
  },
  methods: {
    getVal(val) {
      this.$emit('getVal', val)
    },
    // 更新生效时间类型
    handleContinuedValidityTermChange(value) {
      this.$emit('update:isContinuedValidityTerm', value)
    },
    // 更新生效时间
    handleTimeChange(v) {
      this.$emit('update:useTime', v)
    },
    // 更新发票类型
    handleInvoiceChange(value) {
      this.invoiceDialogVisible = value === 2
      this.invoiceOperateType = 'add'
      this.$emit('invoiceChange', value)
    },
    // 提交发票信息
    handleInvoiceSubmit(formData) {
      this.invoiceDialogVisible = false
      this.$emit('invoiceChange', 2)
      this.$emit('invoiceSubmit', formData)
    },
    // 编辑发票信息弹窗
    handleEditInvoice() {
      this.invoiceOperateType = 'edit'
      this.invoiceDialogVisible = true
    },
    // 输入购买金额
    handleInput(v) {
      this.$emit('inputMoney', v)
    },
    // 输入购买数量
    handleChange(v) {
      this.$emit('inputNum', v)
    },
    // 关闭发票信息弹窗
    closeInvoiceDialog() {
      this.invoiceDialogVisible = false
      this.$emit('closeInvoiceDialog')
      if (this.invoiceOperateType === 'add') {
        this.$emit('invoiceChange', 1)
      }
    },
    // 查看权益
    viewBenefits() {
      window.open(benefitLink, '_blank')
    },
  },
}
</script>

<style lang="less" scoped>
.product-info {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  .row {
    display: flex;
    margin-bottom: 24px;
    .row-label {
      width: 72px;
      font-weight: 400;
      font-size: 14px;
      line-height: 32px;
      color: #333;
      flex-shrink: 0;
    }
    .row-content {
      flex: 1;
      width: calc(100% - 72px);
    }
    .row-content-benefit {
      display: flex;
      align-items: center;
      &-logo {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
      &-detail {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #333333;
        margin-right: 8px;
      }
      .benefits {
        font-weight: 400;
        font-size: 12px;
      }
    }
  }
  .effective-explain {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #bfbfbf;
    margin-top: 4px;
  }
  .base-info {
    display: flex;
    .base-info-title {
      width: 72px;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      color: #333;
    }
    .base-info-detail {
      flex: 1;
      background: #e6f3ff80;
      padding: 14px 10px 14px 20px;
      border-radius: 8px;
      .product-name {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: 0px;
        color: #333;
      }
      .product-desc {
        font-weight: 400;
        font-size: 12px;
        line-height: 16.8px;
        letter-spacing: 0px;
        color: #999;
        margin-top: 4px;
      }
      .base-property {
        margin-top: 12px;
        display: flex;
        flex-wrap: wrap;
        .property-item {
          display: inline-block;
          line-height: 17px;
          border-radius: 4px;
          background: #e6f3ff;
          font-weight: 400;
          font-size: 12px;
          padding: 4px 10px;
          margin-right: 11px;
          color: #333;
          max-width: 299px;
          margin-bottom: 12px;
          &:last-child {
            margin-right: 0;
          }
          .detail-btn {
            margin-left: 8px;
          }
        }
        .subscribe-content {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          .subscribe-content-text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .total-amount {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #333;
        .unit {
          font-size: 12px;
          margin-right: 2px;
        }
      }
    }
  }
  .w-60 {
    width: 160px;
  }
  .w-230 {
    width: 230px;
  }
  .order-time-picker {
    margin-left: 16px;
  }
  .invoice-selection {
    width: 240px;
  }
  .invoce-info {
    margin-top: 8px;
  }
}
</style>
